import React from "react";
import validator from "validator";
import Loader from "../../Loader";
import { openAPI } from "../../../../config";

class UpgradeProfile extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      first_name: "",
      last_name: "",
      company_name: "",
      phone: "",
      error: false,
      info: "",
      isEmployee: false,
      showContent: -1,
      isLoader: false,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.claimProfile = this.claimProfile.bind(this);
    this.onToggleCheckBox = this.onToggleCheckBox.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onChangeHandler = name => event => {
    event.persist();

    if (event.target.value.trim().length === 0) {
      if (this._isMounted) {
        this.setState({
          error: true,
          info: "Field cannot be blank",
          [name]: "",
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          [name]: event.target.value,
          error: false,
          info: "",
        });
      }
    }
  };

  onToggleCheckBox = e => {
    if (this._isMounted) {
      this.setState(prevState => {
        return { isEmployee: !prevState.isEmployee };
      });
    }
  };

  resetForm = () => {
    if (this._isMounted) {
      this.setState({
        success: true,
        info: "",
        email: "",
        first_name: "",
        company_name: "",
        phone: "",
        error: false,
        showContent: -1,
      });
    }
  };

  claimProfile = () => {
    if (this._isMounted) {
      this.setState({ isLoader: true });
    }
    if (
      !this.state.error &&
      Boolean(this.state.first_name) &&
      Boolean(this.state.isEmployee) &&
      Boolean(this.state.phone) &&
      Boolean(this.state.email)
    ) {
      openAPI
        .post(
          `${process.env.REACT_APP_API_URL}/upgrade-vendor-request`,
          {
            email: this.state.email,
            name: `${this.state.first_name} ${this.state.last_name}`,
            company: this.props.companyId,
            phone: this.state.phone,
            employee: this.state.isEmployee,
          },
          {
            withCredentials: true,
          }
        )
        .then(response => {
          if (response.data.success && this._isMounted) {
            this.setState({
              isLoader: false,
              success: true,
              info: "Thank you and a service specialist will be in touch soon.",
              email: "",
              first_name: "",
              last_name: "",
              company_name: "",
              phone: "",
              error: false,
              showContent: response.data.success,
            });
          } else {
            const errors = Object.keys(response.data.error).map(
              err =>
                `${err.charAt(0).toUpperCase()}${err.slice(1)} : ${
                  response.data.message[err][0]
                }`
            );
            if (this._isMounted) {
              this.setState({
                isLoader: false,
                success: true,
                info: errors.join("\n"),
                email: "",
                first_name: "",
                last_name: "",
                company_name: "",
                phone: "",
                error: false,
                showContent: response.data.success,
              });
            }
          }
        });
    } else {
      if (this._isMounted) {
        this.setState({
          error: true,
          info: "Field cannot be blank",
          isLoader: false,
        });
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <section
          className="overlay_popup overlay_grey upgrade_profile_popup footer_popbox"
          aria-hidden="false"
        >
          <div className="popBox">
            <a
              href={"#upgrade"}
              className="close-overlay"
              onClick={e => {
                e.preventDefault();
                this.props.setUpgrade(false);
              }}
            >
              <span className="cross">X</span>
            </a>
            <div className="modal-body">
              <div className="leftSection">
                <div className="left_section_wrap">
                  <div className="logo">
                    <img src="/images/logo_white.webp" />
                  </div>
                  <div className="content">
                    <span className="heading upgrade_profile">
                      Upgrade Profile
                    </span>
                    <p>
                      Let potential prospects find you on the world’s only
                      customer reference platform for B2B solutions &amp;
                      services.
                    </p>
                    <p>
                      Contact us today to take control of your profile for FREE
                      and learn about our upgraded profile options to unlock all
                      of your customer references for prospects to see.
                    </p>
                  </div>
                </div>
              </div>
              <div className="rightSection">
                {this.state.showContent === -1 && (
                  <div className="clsForm">
                    {this.state.success ? (
                      <span style={{ color: "green" }}>{this.state.info}</span>
                    ) : null}
                    {this.state.error ? (
                      <span style={{ color: "red" }}>{this.state.info}</span>
                    ) : null}
                    <form>
                      <label>
                        First Name *
                        <input
                          type="text"
                          placeholder="John"
                          value={this.state.first_name}
                          onChange={this.onChangeHandler("first_name")}
                        />
                      </label>
                      <label>
                        Last Name *
                        <input
                          type="text"
                          placeholder="John"
                          value={this.state.last_name}
                          onChange={this.onChangeHandler("last_name")}
                        />
                      </label>
                      <label>
                        Your Email *
                        <input
                          type="email"
                          placeholder="Email"
                          value={this.state.email}
                          onChange={this.onChangeHandler("email")}
                          onBlur={e => {
                            e.persist();
                            if (
                              !validator.isEmail(e.target.value) &&
                              this._isMounted
                            ) {
                              this.setState({
                                error: true,
                                info: "Invalid email format",
                              });
                            }
                          }}
                        />
                      </label>
                      <label>
                        Phone Number *
                        <input
                          type="tel"
                          placeholder="(555) 555-5555"
                          value={this.state.phone}
                          onChange={this.onChangeHandler("phone")}
                        />
                      </label>
                      {this.props.companyName && (
                        <label>
                          <input
                            type="checkbox"
                            value={this.state.isEmployee}
                            name="claim-employee"
                            id="id_claim-employee"
                            onChange={this.onToggleCheckBox}
                          />
                          <label htmlFor="id_claim-employee">
                            I work for {this.props.companyName}
                          </label>
                        </label>
                      )}
                      <input
                        type="submit"
                        value="Upgrade Profile"
                        onClick={e => {
                          e.preventDefault();
                          this.claimProfile();
                        }}
                      />
                    </form>
                  </div>
                )}
                {this.state.showContent !== -1 && (
                  <div className="clsMsg">
                    {Number(this.state.showContent) === 1 && (
                      <div className="success_msg">
                        <span className="success">
                          <i className="fa fa-check" aria-hidden="true"></i>
                        </span>
                        <p>
                          Thank you and a service specialist will be in touch
                          soon.
                        </p>
                      </div>
                    )}
                    {Number(this.state.showContent) === 0 && (
                      <div className="failure_msg">
                        <span className="failure">
                          <i
                            className="fa fa-exclamation-triangle"
                            aria-hidden="true"
                          ></i>{" "}
                          Unable to save!
                        </span>
                        <p>
                          {Number(this.state.showContent) === 0
                            ? this.state.info
                            : "There was an error, please try again."}
                        </p>
                        <a
                          href={() => false}
                          onClick={e => {
                            e.preventDefault();
                            this.resetForm();
                          }}
                        >
                          Show Form
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {this.state.isLoader ? <Loader /> : null}
      </React.Fragment>
    );
  }
}

export default UpgradeProfile;
